export interface UserValidateModel
{
    Email: string;
    Tid?: string;
    OfferId?: string;
    AffiliateId?: string;
    SubId?: string;
    Source?: number;
}

export interface UserProfileModel
{
    UserName?: string;
    Title?: string;
    FName?: string;
    MName?: string;
    LName?: string;
    DateOfBirth?: Date | string;
    Email?: string;
    ProfileImage?: string;
    CustomerId?: string;
    ReferralCode?: string;
    ReferralVia?: string;
    TrackingId?: string;
    Mobile?: string;
}

export interface AddressModel
{
    id: string;
    address: string;
}

export interface UserAddress
{
    //CustomerId: string,
    //UserName: string;
    Postcode: string;
    AddressId: string;
    Month: string;
    Year: string;
    StartDate: string;
    EndDate: string;
    NoOfAddress: number;
    IsLiveOutSideUk: boolean;
    FlatNumber: string;
    HouseName: string;
    HouseNo: string;
    Street: string;
    Town: string;
    Country: string;
    FullAddress: string;
}

export class UserAddressModel {
    constructor(
        public CustomerId: string,
        public ResidentialStatus: number,
        public UserAddresses: UserAddress []
    ) { }
}

export interface UserAdditionalInfo
{
    CustomerId: string;
    MaritalStatus?: number;
    No_of_Dependents?: string;
    EmploymentStatus?: number;
    IndustryId?: number;
    AnnualSalary?: number;
    AccommodationCost?: number;
}

export interface LoanSearchModel
{
    LoanPurpose: number;
    LoanAmount: number;
    LoanTerm: number;
    LoanType: string;
}

export interface RegistrationRequest
{
    Username: string;
}


export interface UserPrimeInfo
{
    CustomerId: string;
    EmployeerName: string;
    PaymentType: string;
    AnyOtherIncome:number;
    MonthlyCreditCommitments?: number;
    OtherExpenses: number;
    No_of_Adults?: number;
    BankAccountNumber: string;
    SortCode: string;
    BankCardType: string;
    Browser:string;
    LoanPurpose:number;
    LoanAmount : number;
    LoanDuration : number;
}

export class UserAllDetail
{
    LoanPurpose: string ='';
    LoanAmount: string ='';
    LoanTerm: string ='';
    TermTypes: string ='';
    FullName: string ='';
    DateOfBirth: string ='';
    Email: string ='';
    PhoneNo: number =0;
    Postcode: string ='';
    Address: string ='';
    LivingFrom: string ='';
    ResidentialStatus: string='';
    MaritalStatus: string='';
    DependentsNo: string='';
    EmpStatus: string='';
    EmpIndustry: string='';
    AnnualIncome: string='';
    MonthlyAccomCost: string='';
}

export interface StatusRequest
{
    CustomerId: string;
    StatusCheckUrl: string;
}

export interface Industry {
  industryId: number;
  industryName: string;
}

export interface LoanItem {
  cardId: number;
  eligibilityPercentage: number;
  loanKeyFacts?: string;
  linkUrl?: string;
  annualInterestAPR: number;
  monthlyRepayment: number;
  totalRepayableAmount: number;
  providerName: string;
  logId: number;
  correlationId: string;
  repaymentRateType:string;
  representativeExample: string;
  imgUrl: string;
}